const mu = [
  {
    id: 1,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2025",
      "2025 manchester",
      "2025",
      "manchester united 2025",
      "2025 manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mu/25-06-01/uni0.jpg",
      "/images/europa/mu/25-06-01/uni1.jpg",
      "/images/europa/mu/25-06-01/uni2.jpg",
      "/images/europa/mu/25-06-01/uni3.jpg",
      "/images/europa/mu/25-06-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2025",
      "2025 manchester",
      "2025",
      "manchester united 2025",
      "2025 manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mu/25-26-02/uni0.jpg",
      "/images/europa/mu/25-26-02/uni1.jpg",
      "/images/europa/mu/25-26-02/uni2.jpg",
      "/images/europa/mu/25-26-02/uni3.jpg",
      "/images/europa/mu/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 25/26 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2025",
      "2025 manchester",
      "2025",
      "manchester united 2025",
      "2025 manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mu/25-26-03/uni0.jpg",
      "/images/europa/mu/25-26-03/uni1.jpg",
      "/images/europa/mu/25-26-03/uni2.jpg",
      "/images/europa/mu/25-26-03/uni3.jpg",
      "/images/europa/mu/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2025",
      "2025 manchester",
      "2025",
      "manchester united 2025",
      "2025 manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/25-26-00-es/uni0.jpg",
      "/images/europa/mu/25-26-00-es/uni1.jpg",
      "/images/europa/mu/25-26-00-es/uni2.jpg",
      "/images/europa/mu/25-26-00-es/uni3.jpg",
      "/images/europa/mu/25-26-00-es/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2025",
      "2025 manchester",
      "2025",
      "manchester united 2025",
      "2025 manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/25-26-00-es1/uni0.jpg",
      "/images/europa/mu/25-26-00-es1/uni1.jpg",
      "/images/europa/mu/25-26-00-es1/uni2.jpg",
      "/images/europa/mu/25-26-00-es1/uni3.jpg",
      "/images/europa/mu/25-26-00-es1/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2024",
      "2024 manchester",
      "2024",
      "manchester united 2024",
      "2024 manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mu/24-25-01/uni0.jpg",
      "/images/europa/mu/24-25-01/uni1.jpg",
      "/images/europa/mu/24-25-01/uni2.jpg",
      "/images/europa/mu/24-25-01/uni3.jpg",
      "/images/europa/mu/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2024",
      "2024 manchester",
      "2024",
      "manchester united 2024",
      "2024 manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mu/24-23-02/uni0.jpg",
      "/images/europa/mu/24-23-02/uni1.jpg",
      "/images/europa/mu/24-23-02/uni2.jpg",
      "/images/europa/mu/24-23-02/uni3.jpg",
      "/images/europa/mu/24-23-02/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 24/25 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2024",
      "2024 manchester",
      "2024",
      "manchester united 2024",
      "2024 manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mu/24-25-03/uni0.jpg",
      "/images/europa/mu/24-25-03/uni1.jpg",
      "/images/europa/mu/24-25-03/uni2.jpg",
      "/images/europa/mu/24-25-03/uni3.jpg",
      "/images/europa/mu/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 24/25 - Uniforme de Pré jogo",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2024",
      "2024 manchester",
      "2024",
      "manchester united 2024",
      "2024 manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mu/24-25-05-pj/uni0.jpg",
      "/images/europa/mu/24-25-05-pj/uni1.jpg",
      "/images/europa/mu/24-25-05-pj/uni2.jpg",
      "/images/europa/mu/24-25-05-pj/uni3.jpg",
      "/images/europa/mu/24-25-05-pj/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 24/25 - Uniforme de Pré jogo",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2024",
      "2024 manchester",
      "2024",
      "manchester united 2024",
      "2024 manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mu/24-25-06-pj/uni0.jpg",
      "/images/europa/mu/24-25-06-pj/uni1.jpg",
      "/images/europa/mu/24-25-06-pj/uni2.jpg",
      "/images/europa/mu/24-25-06-pj/uni3.jpg",
      "/images/europa/mu/24-25-06-pj/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 23/24 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2023",
      "2023 manchester",
      "2023",
      "manchester united 2023",
      "2023 manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mu/23-24-02/uni0.jpg",
      "/images/europa/mu/23-24-02/uni1.jpg",
      "/images/europa/mu/23-24-02/uni2.jpg",
      "/images/europa/mu/23-24-02/uni3.jpg",
      "/images/europa/mu/23-24-02/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 21/22 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2021",
      "2021 manchester",
      "2021",
      "manchester united 2021",
      "2021 manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mu/21-22-01/uni0.jpg",
      "/images/europa/mu/21-22-01/uni1.jpg",
      "/images/europa/mu/21-22-01/uni2.jpg",
      "/images/europa/mu/21-22-01/uni3.jpg",
      "/images/europa/mu/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 19/20 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2019",
      "2019 manchester",
      "2019",
      "manchester united 2019",
      "2019 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/19-20-02-rt/uni0.png",
      "/images/europa/mu/19-20-02-rt/uni1.png",
      "/images/europa/mu/19-20-02-rt/uni2.png",
      "/images/europa/mu/19-20-02-rt/uni3.png",
      "/images/europa/mu/19-20-02-rt/uni4.png",
    ],
  },
  {
    id: 14,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 18/19 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2018",
      "2018 manchester",
      "2018",
      "manchester united 2018",
      "2018 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/18-19-02-rt/uni0.jpg",
      "/images/europa/mu/18-19-02-rt/uni1.jpg",
      "/images/europa/mu/18-19-02-rt/uni2.jpg",
      "/images/europa/mu/18-19-02-rt/uni3.jpg",
      "/images/europa/mu/18-19-02-rt/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 16/17 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2016",
      "2016 manchester",
      "2016",
      "manchester united 2016",
      "2016 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/16-17-01-rt/uni0.jpg",
      "/images/europa/mu/16-17-01-rt/uni1.jpg",
      "/images/europa/mu/16-17-01-rt/uni2.jpg",
      "/images/europa/mu/16-17-01-rt/uni3.jpg",
      "/images/europa/mu/16-17-01-rt/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 11/12 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2011",
      "2011 manchester",
      "2011",
      "manchester united 2011",
      "2011 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/11-12-02-rt/uni0.jpg",
      "/images/europa/mu/11-12-02-rt/uni1.jpg",
      "/images/europa/mu/11-12-02-rt/uni2.jpg",
      "/images/europa/mu/11-12-02-rt/uni3.jpg",
      "/images/europa/mu/11-12-02-rt/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 08/09 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2008",
      "2008 manchester",
      "2008",
      "manchester united 2008",
      "2008 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/08-09-02-rt/uni0.jpg",
      "/images/europa/mu/08-09-02-rt/uni1.jpg",
      "/images/europa/mu/08-09-02-rt/uni2.jpg",
      "/images/europa/mu/08-09-02-rt/uni3.jpg",
      "/images/europa/mu/08-09-02-rt/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 07/08 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2007",
      "2007 manchester",
      "2007",
      "manchester united 2007",
      "2007 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/07-08-01-rt/uni0.jpg",
      "/images/europa/mu/07-08-01-rt/uni1.jpg",
      "/images/europa/mu/07-08-01-rt/uni2.jpg",
      "/images/europa/mu/07-08-01-rt/uni3.jpg",
      "/images/europa/mu/07-08-01-rt/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 07/08 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2007",
      "2007 manchester",
      "2007",
      "manchester united 2007",
      "2007 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/07-08-03-rt/uni0.jpg",
      "/images/europa/mu/07-08-03-rt/uni1.jpg",
      "/images/europa/mu/07-08-03-rt/uni2.jpg",
      "/images/europa/mu/07-08-03-rt/uni3.jpg",
      "/images/europa/mu/07-08-03-rt/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 07/08 - Uniforme de Goleiro Retrô",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2007",
      "2007 manchester",
      "2007",
      "manchester united 2007",
      "2007 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/07-08-05-gc-rt/uni0.jpg",
      "/images/europa/mu/07-08-05-gc-rt/uni1.jpg",
      "/images/europa/mu/07-08-05-gc-rt/uni2.jpg",
      "/images/europa/mu/07-08-05-gc-rt/uni3.jpg",
      "/images/europa/mu/07-08-05-gc-rt/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 06/07 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2006",
      "2006 manchester",
      "2006",
      "manchester united 2006",
      "2006 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/06-07-01-rt/uni0.jpg",
      "/images/europa/mu/06-07-01-rt/uni1.jpg",
      "/images/europa/mu/06-07-01-rt/uni2.jpg",
      "/images/europa/mu/06-07-01-rt/uni3.jpg",
      "/images/europa/mu/06-07-01-rt/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 05/06 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2005",
      "2005 manchester",
      "2005",
      "manchester united 2005",
      "2005 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/05-06-02-rt/uni0.jpg",
      "/images/europa/mu/05-06-02-rt/uni1.jpg",
      "/images/europa/mu/05-06-02-rt/uni2.jpg",
      "/images/europa/mu/05-06-02-rt/uni3.jpg",
      "/images/europa/mu/05-06-02-rt/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 02/03 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 2002",
      "2002 manchester",
      "2002",
      "manchester united 2002",
      "2002 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/02-03-01-rt/uni0.jpg",
      "/images/europa/mu/02-03-01-rt/uni1.jpg",
      "/images/europa/mu/02-03-01-rt/uni2.jpg",
      "/images/europa/mu/02-03-01-rt/uni3.jpg",
      "/images/europa/mu/02-03-01-rt/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 98/99 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 1998",
      "1998 manchester",
      "1998",
      "manchester united 1998",
      "1998 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/98-99-01-rt/uni0.jpg",
      "/images/europa/mu/98-99-01-rt/uni1.jpg",
      "/images/europa/mu/98-99-01-rt/uni2.jpg",
      "/images/europa/mu/98-99-01-rt/uni3.jpg",
      "/images/europa/mu/98-99-01-rt/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 98/99 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 1998",
      "1998 manchester",
      "1998",
      "manchester united 1998",
      "1998 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/98-99-02-rt/uni0.jpg",
      "/images/europa/mu/98-99-02-rt/uni1.jpg",
      "/images/europa/mu/98-99-02-rt/uni2.jpg",
      "/images/europa/mu/98-99-02-rt/uni3.jpg",
      "/images/europa/mu/98-99-02-rt/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 98/99 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 1998",
      "1998 manchester",
      "1998",
      "manchester united 1998",
      "1998 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/98-99-03-rt/uni0.jpg",
      "/images/europa/mu/98-99-03-rt/uni1.jpg",
      "/images/europa/mu/98-99-03-rt/uni2.jpg",
      "/images/europa/mu/98-99-03-rt/uni3.jpg",
      "/images/europa/mu/98-99-03-rt/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 94/95 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 1994",
      "1994 manchester",
      "1994",
      "manchester united 1994",
      "1994 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/94-95-01-rt/uni0.jpg",
      "/images/europa/mu/94-95-01-rt/uni1.jpg",
      "/images/europa/mu/94-95-01-rt/uni2.jpg",
      "/images/europa/mu/94-95-01-rt/uni3.jpg",
      "/images/europa/mu/94-95-01-rt/uni4.jpg",
    ],
  },
  {
    id: 28,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 90/91 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 1990",
      "1990 manchester",
      "1990",
      "manchester united 1990",
      "1990 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/90-91-01-rt/uni0.png",
      "/images/europa/mu/90-91-01-rt/uni1.png",
      "/images/europa/mu/90-91-01-rt/uni2.jpg",
      "/images/europa/mu/90-91-01-rt/uni3.jpg",
      "/images/europa/mu/90-91-01-rt/uni4.jpg",
    ],
  },
  {
    id: 29,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United 88/89 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester 1988",
      "1988 manchester",
      "1988",
      "manchester united 1988",
      "1988 manchester united",
      "manchester retro",
      "retro manchester",
      "retro",
      "manchester united retro",
      "retro manchester united",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/mu/88-89-02-rt/uni0.jpg",
      "/images/europa/mu/88-89-02-rt/uni1.jpg",
      "/images/europa/mu/88-89-02-rt/uni2.jpg",
      "/images/europa/mu/88-89-02-rt/uni3.jpg",
      "/images/europa/mu/88-89-02-rt/uni4.jpg",
    ],
  },
  {
    id: 30,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United - Jaqueta (Azul)",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester jaqueta",
      "jaqueta manchester",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mu/jac/uni0.jpg",
      "/images/europa/mu/jac/uni1.jpg",
      "/images/europa/mu/jac/uni2.jpg",
      "/images/europa/mu/jac/uni3.jpg",
      "/images/europa/mu/jac/uni4.jpg",
    ],
  },
  {
    id: 31,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United - Jaqueta (Azul)",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester jaqueta",
      "jaqueta manchester",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mu/jae/uni0.jpg",
      "/images/europa/mu/jae/uni1.jpg",
      "/images/europa/mu/jae/uni2.jpg",
      "/images/europa/mu/jae/uni3.jpg",
      "/images/europa/mu/jae/uni4.jpg",
    ],
  },
  {
    id: 31,
    pais: "europa",
    liga: "premier-league",
    time: "manchester-united",
    nome: "Manchester United - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "manchester united",
      "manchester",
      "red devils",
      "manchester jaqueta",
      "jaqueta manchester",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/mu/jp/uni0.jpg",
      "/images/europa/mu/jp/uni1.jpg",
      "/images/europa/mu/jp/uni2.jpg",
      "/images/europa/mu/jp/uni3.jpg",
      "/images/europa/mu/jp/uni4.jpg",
    ],
  },
];

export default mu;
